import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['bankTransferVisibleField', 'directDebitHiddenField', 'select']

  connect() {
    const changeEvent = new Event('change')
    this.selectTarget.dispatchEvent(changeEvent)
  }

  select() {
    const currentPaymentMethod = event.currentTarget.value

    this.bankTransferVisibleFieldTargets.forEach(field => {
      if (currentPaymentMethod == 'bank_transfer') {
        field.style.display = 'unset'
      } else {
        field.style.display = 'none'
      }
    })

    this.directDebitHiddenFieldTargets.forEach(field => {
      if (currentPaymentMethod == 'direct_debit') {
        field.style.display = 'none'
      } else {
        field.style.display = 'unset'
      }
    })
  }
}
